import React from 'react';
import PageSerch from './SerchDocters/Components/PageSerch';
import DynamicBreadcrumbs from '../../Uitiles/DynamicBreadcrumbs';

const ShippingPolicy = () => {
    return (
        <div>
            <PageSerch />
            <DynamicBreadcrumbs />
            <main id="dc-main" className="dc-main dc-haslayout">
                <div className="container">
                    <div className="dc-haslayout dc-haslayout page-data dc-parent-section dc-disabled">
                        <div className="main-page-wrapper">
                            <div className="dc-description">
                                <div className="p-6 max-w-3xl mx-auto">
                                    <h1 className="text-2xl font-bold mb-4">Shipping Policy</h1>
                                    <p className="mb-4">
                                        MeddyList does not sell, distribute, or ship any products directly. We are an online healthcare 
                                        listing and information platform only. Any products or services displayed on our website 
                                        (such as medical or pharmacy items) are shown for informational purposes and belong to 
                                        third-party sellers or service providers.
                                    </p>
                                    <p className="mb-4">
                                        If you are interested in any listed product or service, please contact the respective 
                                        seller, hospital, clinic, or pharmacy directly using the contact details provided on their profile.
                                    </p>
                                    <p>
                                        MeddyList is not involved in the order processing, payment collection, shipping, or 
                                        delivery of any goods or services listed on the platform.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default ShippingPolicy;
